import React from 'react'
import { Card, CardContent, Stack, Typography } from '@mui/material'
import useFetch from 'common/hooks/useFetch'
import ApplicationConf from 'conf/ApplicationConf'
import PropTypes from 'prop-types'

const StatCard = ({ label, value, sub }) => (
    <Card sx={{ flexGrow: 1, height: '100%' }}>
        <CardContent sx={{ '&:last-child': { paddingBottom: 2 } }}>
            <Typography variant='h4'>{value}</Typography>
            <Typography variant='body2' color='textSecondary'>{label}</Typography>
            {sub && <Typography variant='caption' color='textSecondary'>{sub}</Typography>}
        </CardContent>
    </Card>
)

StatCard.propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sub: PropTypes.string,
}

const RecetteStatsCards = ({ nbToCome }) => {
    const { data = {} } = useFetch(ApplicationConf.support.statisticsRecette())

    const { dureeMoyenneJours, dureeEnCoursJours, tauxRetourDev, nbRetours, nbEnRecette } = data

    return (
        <Stack direction='row' spacing={2} sx={{ flexGrow: 1 }}>
            <StatCard
                label='Durée moyenne des 5 dernières recettes'
                value={Number.isFinite(dureeMoyenneJours) ? `${dureeMoyenneJours} j` : '—'}
                sub={`${Number.isFinite(dureeEnCoursJours) ? `Recette en cours : ${dureeEnCoursJours} j` : ''}`}
            />
            <StatCard
                label='Retours aux devs en recette'
                value={Number.isFinite(tauxRetourDev) ? `${tauxRetourDev} %` : '—'}
                sub={Number.isFinite(nbEnRecette) ? `${nbRetours ?? 0}/${nbEnRecette} repassés en « Réouvert » (5 dernières recettes)` : ''}
            />
            <StatCard
                label='Tickets à venir pour la prochaine recette'
                value={Number.isFinite(nbToCome) ? nbToCome : '—'}
                sub='En attente de validation interne'
            />
        </Stack>
    )
}

RecetteStatsCards.propTypes = {
    nbToCome: PropTypes.number,
}

export default RecetteStatsCards
